// Wire protocol version (§20.1). Bump on any incompatible change to messages or binary schemas.
export const PROTOCOL_VERSION = 1;

/** A `hello` whose version fails this check gets `error VERSION_MISMATCH`. */
export function isCompatibleVersion(v: unknown): boolean {
  return v === PROTOCOL_VERSION;
}
